import { useState } from "react";
import { DatePicker, Button, Spin } from "antd";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import ModalBase from "../lib/common/ModalBase";
import { useAPI } from "../lib/hook/APIProvider";
import { useModal } from "../lib/modal/ModalContext";

const KPIDownloadModal: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const { client } = useAPI();
  const { hideModal } = useModal();
  const handleDownload = async () => {
    if (!startDate || !endDate) {
      alert("시작 날짜와 끝 날짜를 모두 선택해주세요.");
      return;
    }

    setIsLoading(true);

    try {
      const result = await client.get(
        `/preview/tcms/ImpVehicleKPIV?from=${startDate.toLocaleDateString(
          "sv-SE"
        )}&to=${endDate.toLocaleDateString("sv-SE")}`,
        { timeout: 0 }
      );

      const data = result.data;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("KPI Data");

      const headers = [
        "차대번호",
        "신고번호",
        "브랜드",
        "요청시각",
        "누적적용건수",
        "목표시각",
        "수리시각",
        "성공여부",
        "신고구분",
        "지연사유",
      ];

      worksheet.addRow(headers);

      data.forEach((row: any) => {
        worksheet.addRow([
          row.차대번호,
          row.신고번호,
          row.브랜드,
          row.요청시각 ,
          row.누적적용건수,
          row.목표시각,
          row.수리시각 ,
          row.성공여부,
          row.신고구분,
          row.지연사유,
        ]);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `KPI_Data_${new Date().toISOString().split("T")[0]}.xlsx`);
    } catch (error) {
      console.error(error);
      alert("다운로드 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
      hideModal();
    }
  };

  return (
    <ModalBase>
      <div className="bg-white p-4 space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">시작 날짜</label>
          <DatePicker
            placeholder="시작 날짜 선택"
            style={{ width: "100%" }}
            onChange={(date :any) => setStartDate(date?.toDate() ?? null)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">끝 날짜</label>
          <DatePicker
            placeholder="끝 날짜 선택"
            style={{ width: "100%" }}
            onChange={(date:any) => setEndDate(date?.toDate() ?? null)}
          />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button
            type="default"
            onClick={() => hideModal()}
            disabled={isLoading}
          >
            취소
          </Button>
          <Button type="default" loading={isLoading} onClick={handleDownload}>
            다운로드
          </Button>
        </div>
      </div>
    </ModalBase>
  );
};
export default KPIDownloadModal;
